import React, { useState, useEffect } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";
import * as Const from "./_Const";
import * as Helper from "./_Helper";
import * as VS from "./services/ValidatorService";

import Keyboard from "./components/Keyboard";
import Input from "./components/Input";
import Navbar from "./components/Navbar";
import Button from "./components/Button";

import { useLocalStorage, useSessionStorage } from "./hooks/useStorage";

function PageTerminalId() {
  function getUid() {
    const localUid = Helper.decrypt(storageUid);
    console.log("nacitam z storage uid: " + localUid);
    return localUid;
  }

  const [storageUid, setStorageUid, removeStorageUid] = useSessionStorage(Const.SS_UID, "");
  const [uid, setUid] = useState(getUid());

  const [isError, setError] = useState(false);
  const { navigateHome } = useFormCtx();

  const isTerminal = Const.isTerminal();
  /*
  useEffect(() => {
    setUid(getUid());
  }, []);*/

  function setUidManually(uid) {
    let isSaved = false;
    //kdyz neni prazdne tak ho ulozim
    if (!VS.isEmpty(uid)) {
      //console.log("ukladam uid: " + uid);
      setStorageUid(Helper.encrypt(uid));
      isSaved = true;
    }
    return isSaved;
  }

  function handleSave() {
    const isSaved = setUidManually(uid);
    setError(!isSaved);
    if (isSaved) {
      navigateHome(uid);
    }
  }

  function handleInput(val) {
    const isValid = VS.isEmpty(val);
    setError(isValid);
    setUid(val);
  }

  return (
    <>
      <div className="flex flex-col h-dvh overflow-hidden">
        <div className="flex-1 overflow-y-scroll pb-6 overflow-x-hidden">
          <Navbar />
          <div className="mt-4 flex flex-col space-y-4 mx-6">
            <div className="container mx-auto overflow-x-hidden">
              <div className="mt-4">
                <Input
                  label="ID terminálu"
                  name="terminalId"
                  value={uid}
                  errorMessage={isError ? "Vyplňte ID terminálu" : ""}
                  autoComplete="off"
                  showLabel={true}
                  readOnly={true}
                />
              </div>
              <div className="mt-4">
                <Keyboard type={"hex"} onChange={(e) => handleInput(e)} value={uid} />
              </div>
            </div>
          </div>
        </div>

        {isTerminal && (
          <footer className="">
            <div className="grid">
              <div className="col-span-3 w-full justify-self-center">
                <Button type="primary" title="Uložit" className={"w-full h-20 rounded-none text-3xl"} showIcon={false} onClick={handleSave} />
              </div>
            </div>
          </footer>
        )}
      </div>
    </>
  );
}

export default PageTerminalId;
